module.exports = __webpack_public_path__ + "static/bbis-geo-min-da52e1778f047616d4de463caa2e5e5b.jpg";